import React, { useState, useRef } from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { RightOutlined } from '@ant-design/icons';

import DragHandle from 'components/DragHandle';
import classnames from 'shared/utils/classnames';

import './sortable-collapse.less';

const Handle = SortableHandle(() => <DragHandle />);

const Panel = SortableElement(({ header, extra, children }) => {
  const [expanded, setExpanded] = useState(false);
  const toggleCollapse = () => setExpanded(!expanded);

  return (
    <div className={classnames('panel', expanded && 'panel--expanded')}>
      <div className="panel__header" onClick={toggleCollapse} role="presentation">
        <Handle />
        <RightOutlined className="collapse-icon" />
        <span className="header-content">{header}</span>
        {extra && (<div className="actions">{extra}</div>)}
      </div>
      {expanded && (
        <div className="panel__content">{children}</div>
      )}
    </div>
  );
});

const SortContainer = SortableContainer(({ children }) => (
  // Sortable Components should be wrapped by DOM element
  // in order to calculate its position
  <div>{children}</div>
));

const Collapse = ({ children, ...rest }) => {
  const ref = useRef();
  const getHelperContainer = () => ref.current;

  return (
    <div className="sortable-collapse" ref={ref}>
      <SortContainer helperContainer={getHelperContainer} useDragHandle lockAxis="y" {...rest}>
        {children}
      </SortContainer>
    </div>
  );
};

Collapse.Panel = Panel;

export default Collapse;
